import React from 'react';

export function createStyledSelect(SelectComponent, customStyles) {
  class SelectWrapper extends React.PureComponent {
    render() {
      const { styles, ...props } = this.props;

      return (
        <SelectComponent styles={{ ...customStyles, ...styles }} {...props} />
      );
    }
  }

  return SelectWrapper;
}
